// Per-(instrument category, line) default finish for the configurator preview.
//
// Single-finish lines (everything except Aurora One) render one uncolored steel
// finish by default. Acoustic + Ultra-Sheer is the exception: the set finish is
// Phos (bronze) with plain strings shown gold, matching the real product.
//
// setColorSlug   → color slug pre-selected as the set color (drives Review/pricing)
// setHex/plainHex → render hexes for the fretboard default-preview path. plainHex
//                   paints plain strings, setHex paints wound strings. Absent on
//                   the natural default so the board stays steel until a color is
//                   chosen (unchanged behavior for every other line).

import type { ColorOption } from "@/types/configurator";

export interface ConfiguratorFinish {
  setColorSlug: string;
  setColorName?: string;
  setHex?: string;
  plainHex?: string;
}

const DEFAULT_FINISH: ConfiguratorFinish = {
  setColorSlug: "natural",
};

export function configuratorFinish(
  category: string | null | undefined,
  lineSlug: string | null | undefined,
): ConfiguratorFinish {
  if (category === "acoustic" && lineSlug === "ultra-sheer") {
    // Phos bronze wound strings, gold plains.
    return { setColorSlug: "phos", setColorName: "Phos Bronze", setHex: "#B08D57", plainHex: "#E8C547" };
  }
  return DEFAULT_FINISH;
}

/**
 * A synthetic palette swatch for a non-default finish, so the finish color is
 * selectable even when the line's own color list doesn't include it (e.g. the
 * Ultra-Sheer line only carries "natural"). Returns null for the plain default.
 */
export function finishColorOption(
  finish: ConfiguratorFinish,
  instrumentSlug: string
): ColorOption | null {
  if (!finish.setHex || !finish.setColorName) return null;
  return {
    id: `finish-${finish.setColorSlug}`,
    name: finish.setColorName,
    slug: finish.setColorSlug,
    hexCode: finish.setHex,
    swatchCss: null,
    instrumentSlug,
  };
}
